import React, { memo } from 'react';
import { LeadPopGame } from 'lead-pop';

/**
 * Embeds lead-pop during ENRICHING. No round timer; ends when `sessionComplete` is true.
 * @param {{
 *   literals: Record<string, string>,
 *   sessionComplete: boolean,
 *   onViewProspectingResults: () => void,
 *   enrichmentProgress?: { current: number, total: number },
 *   backendLeadQueue?: Array<{ row: object, key?: string }>,
 * }} props
 */
function LeadPopEnrichingPanel({
    literals,
    sessionComplete,
    onViewProspectingResults,
    enrichmentProgress,
    backendLeadQueue,
}) {
    return (
        <div className="fm-leads-modal__lead-pop-host">
            <LeadPopGame
                useDurationLimit={false}
                sessionComplete={sessionComplete}
                onPrimaryResultAction={onViewProspectingResults}
                difficulty="normal"
                autoStart
                showStartBanner
                literals={literals}
                enrichmentProgress={enrichmentProgress}
                backendLeadQueue={backendLeadQueue}
            />
        </div>
    );
}

export default memo(LeadPopEnrichingPanel);
